import { render, staticRenderFns } from "./SimpleKPIWidget.vue?vue&type=template&id=69dfde73&scoped=true"
import script from "./SimpleKPIWidget.vue?vue&type=script&lang=js"
export * from "./SimpleKPIWidget.vue?vue&type=script&lang=js"
import style0 from "./SimpleKPIWidget.vue?vue&type=style&index=0&id=69dfde73&prod&lang=scss"
import style1 from "./SimpleKPIWidget.vue?vue&type=style&index=1&id=69dfde73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dfde73",
  null
  
)

export default component.exports